import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Home, CalendarDays, Plus, Images, User2 } from 'lucide-react';
import { motion } from 'framer-motion';

const items = [
  { to: '/', label: 'Home', icon: Home, testid: 'bottom-nav-home' },
  { to: '/events', label: 'Events', icon: CalendarDays, testid: 'bottom-nav-events' },
  { to: '/memories', label: 'Memories', icon: Images, testid: 'bottom-nav-memories' },
  { to: '/profile', label: 'Profile', icon: User2, testid: 'bottom-nav-profile' },
];

export const BottomNav = () => {
  const navigate = useNavigate();
  return (
    <div className="fixed bottom-0 inset-x-0 z-[10000] pointer-events-none">
      <div className="max-w-[640px] mx-auto px-3 pb-3 pt-1 safe-bottom">
        <div className="pointer-events-auto relative flex items-center justify-between glass-card rounded-3xl border border-border shadow-[0_18px_50px_-22px_rgba(15,23,42,0.45)] px-3 py-2">
          {items.slice(0, 2).map((it) => (
            <NavItem key={it.to} {...it} />
          ))}
          {/* center FAB spacer */}
          <div className="w-16 h-12 flex items-center justify-center" aria-hidden />
          {items.slice(2).map((it) => (
            <NavItem key={it.to} {...it} />
          ))}
        </div>
        <motion.button
          whileTap={{ scale: 0.94 }}
          whileHover={{ y: -2 }}
          onClick={() => navigate('/events/new')}
          aria-label="Create new event"
          data-testid="bottom-nav-create-fab"
          className="pointer-events-auto absolute left-1/2 -translate-x-1/2 -top-1 h-14 w-14 rounded-2xl text-white shadow-[0_18px_50px_-22px_rgba(15,23,42,0.55)] gradient-fab flex items-center justify-center"
        >
          <Plus className="h-6 w-6" />
        </motion.button>
      </div>
    </div>
  );
};

const NavItem = ({ to, label, icon: Icon, testid }) => (
  <NavLink
    to={to}
    end={to === '/'}
    data-testid={testid}
    className={({ isActive }) =>
      `flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-xl text-[11px] font-medium transition-colors ${
        isActive ? 'text-[hsl(var(--primary))]' : 'text-muted-foreground hover:text-foreground'
      }`
    }
  >
    {({ isActive }) => (
      <>
        <Icon className={`h-5 w-5 ${isActive ? 'stroke-[2.4]' : 'stroke-2'}`} />
        <span>{label}</span>
      </>
    )}
  </NavLink>
);
